require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-in-its-rapid-response-to-covid-19-the-world-bank-has.json") })
        }
      }, "path---en-us-update-in-its-rapid-response-to-covid-19-the-world-bank-has");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-in-its-rapid-response-to-covid-19-the-world-bank-has!./.cache/json/en-us-update-in-its-rapid-response-to-covid-19-the-world-bank-has.json
// module id = 758
// module chunks = 231608221292675